import routesLimited from '@/constants/routesLimited'
import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { RouteRecordRaw } from 'vue-router'

const personRolePermissions: RouteRecordRaw = {
	components: {
		rolePermissions: () =>
			import('components/modules/Persons/Person/RolePermissions.vue'),
	},
	name: 'person',
	path: '',
	props: castRouteIds,
	// Kein meta.subs: das ist die Standard-Kindroute von /persons/:id; role_permissions hier hätte
	// mit subscriptionGuard die ganze Personenseite gesperrt (der Tab ist in Person.vue nicht abo-gesperrt).
}
const person: RouteRecordRaw = {
	children: [personRolePermissions],
	component: () => import('components/modules/Persons/Person/Person.vue'),
	meta: {
		icon: 'fa-fw fas fa-user',
		name: 'person',
		validateItem: true,
		title: 'Person',
	},
	path: '/persons/:id',
	props: castRouteIds,
}
const personsList: RouteRecordRaw = {
	component: () => import('components/modules/Persons/PersonList.vue'),
	name: 'persons',
	meta: {
		offline: true,
	},
	path: '',
}
const persons: RouteRecordRaw = {
	children: [personsList, person],
	component: () => import('components/modules/Persons/PersonsLayout.vue'),
	meta: {
		auth: true,
		breadcrump: 'routeTitle.persons',
		icon: 'fa-fw far fa-address-book',
		nav: true,
		title: 'common.list',
		name: 'persons',
		subs: [routesLimited.subModules.persons],
		offline: true,
	},
	path: '/persons',
}
const roles: RouteRecordRaw = {
	component: () => import('components/modules/Persons/Roles.vue'),
	meta: {
		title: 'routeTitle.roles',
		icon: 'fa-fw fas fa-user-friends',
		auth: true,
		offline: true,
		nav: true,
	},
	name: 'roles',
	path: '/roles',
}
export const personsGroup: RouteRecordRaw = {
	children: [persons, roles],
	component: () => import('components/modules/PassThrough.vue'),
	meta: {
		auth: true,
		icon: 'fa-fw fas fa-users',

		nav: true,
		offline: true,
		ordering: 2,
		title: 'routeTitle.persons',
	},
	name: 'persons_group',
	path: '/persons_group',
	redirect: { name: 'persons' },
}

export const personsGroupRoutes: RouteRecordRaw[] = [
	personsGroup,
	person,
	roles,
	persons,
	personRolePermissions,
]
